export var ButtonTheme;
(function (ButtonTheme) {
    ButtonTheme["White"] = "white";
    ButtonTheme["Orange"] = "orange";
    ButtonTheme["Teal"] = "teal";
})(ButtonTheme || (ButtonTheme = {}));
export var VariantTheme;
(function (VariantTheme) {
    VariantTheme["White"] = "white";
    VariantTheme["Black"] = "black";
    VariantTheme["Teal"] = "teal";
})(VariantTheme || (VariantTheme = {}));
